import { combineReducers } from "redux";

import _notif from "./notification";

const rootReducer = combineReducers({
  notif: _notif.reducer,
});

export default rootReducer;
